module.exports = __webpack_public_path__ + "static/media/merge.38e10eca.png";